import React from 'react';
import OverPack from 'rc-scroll-anim/lib/ScrollOverPack';
import QueueAnim from 'rc-queue-anim';
import { getChildrenToRender } from './utils';



class Content133 extends React.PureComponent {
  render() {
    const { ...props } = this.props;
    const { dataSource } = props;
    delete props.dataSource;
    delete props.isMobile;
    return (
      <OverPack {...props} {...dataSource.OverPack}>
        <QueueAnim
          type="bottom"
          leaveReverse
          key="page"
          delay={[0, 100]}
        >
          <div  key="title"  {...dataSource.titleWrapper}>
            {dataSource.titleWrapper.children.map(getChildrenToRender)}
            <div name='content' className='content-wrapper title-content' style={{ opacity: 1, transform: 'translate(0px, 0px)' }}>
              <div className='left'>
                <div className="left-content">
                  <div className="title">
                    <div>SAAS<br />&APP</div>
                  </div>
                  <div className='content content-1'>
                    <span>智能综合调度管控系统</span>
                    <span>设备智能管理</span>
                    <span>数据分析与决策支持系统</span>
                    <span>矿山软件应用</span>
                  </div>
                </div>
                <div className="left-content">
                  <div className="title">
                    <div>PAAS</div>
                  </div>
                  <div className='content content-2'>
                    <div>
                      <p>Alaas</p>
                      <p>
                        <span>领域模型</span>
                        <span>算法库</span>
                        <span>ML训练</span>
                        <span>特征工程</span>
                      </p>
                    </div>
                    <div>
                      <p>业务中台</p>
                      <p>
                        <span>租户管理</span>
                        <span>零代码表单</span>
                        <span>权限中心</span>
                        <span>企业知识库</span>
                        <span>流程引擎</span>
                      </p>
                    </div>
                    <div>
                      <p>数据中台</p>
                      <p>
                        <span>数据湖</span>
                        <span>数据智能</span>
                        <span>数据服务</span>
                      </p>
                    </div>
                    <div>
                      <p>物联中台</p>
                      <p>
                        <span>物联网</span>
                        <span>设备接入</span>
                        <span>设备调试</span>
                        <span>设备日志</span>
                        <span>时序数据</span>
                      </p>
                    </div>
                    <div>
                      <p>可视化中台</p>
                      <p>
                        <span>BI&MAX</span>
                        <span>3D孪生</span>
                        <span>图形插件</span>
                      </p>
                    </div>
                    <div>
                      <p>技术中台</p>
                      <p>
                        <span>容器编排</span>
                        <span>设备接入</span>
                        <span>设备调试</span>
                        <span>设备日志</span>
                      </p>
                    </div>
                  </div>
                </div>
                <div className="left-content">
                  <div className="title">
                    <div>IAAS</div>
                  </div>
                  <div className='content content-3'>
                    <span>私有云</span>
                    <span>公有云</span>
                    <span>混合云</span>
                    <span>云储存</span>
                    <span>云安全</span>
                  </div>
                </div>
                <div className="left-content">
                  <div className="title">
                    <div>网络层</div>
                  </div>
                  <div className='content content-4'>
                    <span>4G/5G</span>
                    <span>LORA</span>
                    <span>NB-IOT</span>
                    <span>WIFI</span>
                  </div>
                </div>
                <div className="left-content">
                  <div className="title">
                    <div>边缘层</div>
                  </div>
                  <div className='content content-5'>
                    <div className="content-5-title">
                      <h3>接口层</h3>
                      <h3>处理层</h3>
                      <h3>接入层</h3>
                      <h3>现场层</h3>
                    </div>
                    <div className="content-5-content">
                      <div>
                        <p>
                          <span>OPC UA</span>
                          <span>Web Socket</span>
                          <span>MQTT</span>
                          <span>COAP</span>
                          <span>......</span>
                        </p>
                      </div>
                      <div>
                        <p>
                          <span>设备本体模型</span>
                          <span>算法功能库</span>
                          <span>容器编排</span>
                          <span>协调计算</span>
                          <span>时序持久化</span>
                        </p>
                      </div>
                      <div>
                        <p>
                          <span>协议解析</span>
                        </p>
                        <p>
                          <span>接入管理</span>
                        </p>
                      </div>
                      <div>
                        <p>
                          <span>现场层</span>
                          <span>生产制造</span>
                          <span>物流仓储</span>
                          <span>检测仪器</span>
                          <span>能源监测</span>
                          <span>......</span>
                        </p>
                        <p>
                          <span>嵌入式软件</span>
                        </p>
                        <p>
                          <span>工业IDC</span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='right'>
                <span>标准化体系</span>
                <span>生态体系</span>
                <span>安全体系</span>
              </div>
            </div>
          </div>
        </QueueAnim>
      </OverPack>
    );
  }
}

export default Content133;
